import React, { useEffect, useRef, useState } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';


const Information = () => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} style={{ position: 'relative', marginRight: '10px' }}>
      {/* <InfoOutlinedIcon
        titleAccess="Information"
        style={{ cursor: 'pointer', color: '#444343' }}
        onClick={() => setOpen((prev) => !prev)}
      /> */}
       <a href="#"  onClick={() => setOpen((prev) => !prev)}>
          <img src="/assets/info.svg" alt="Information" />
      </a>

      {open && (
       <div
       className="notification-dropdown"
       style={{
         position: 'absolute',
         top: '35%',
         right: 0,
         fontSize: '14px',
         marginTop: '10px',
         width: '320px',
         backgroundColor: '#fff',
         border: '1px solid #e0e0e0',
         borderRadius: '12px',
         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
         zIndex: 1000,
         padding: '1rem',
         lineHeight: 1.6,
       }}
     >
       <p style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '0.75rem' }}>
         Information
       </p>
       <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
         <li style={{ marginBottom: '8px' }}>
           <strong>FLI</strong> — Flowlogic Index
         </li>
         <li style={{ marginBottom: '8px' }}>
           <strong>Appr</strong> — Appreciation
         </li>
         <li style={{ marginBottom: '8px' }}>
           <strong>Prop. Value</strong> — Property Value
         </li>
       </ul>
     </div>
      )}
    </div>
  );
};

export default Information;
